<template>
	<div v-if="hasPageDescription" class="footer-help-btn">
		<v-btn
			icon
			size="small"
			variant="text"
			@click="dialog = true"
		>
			<v-icon size="20">mdi-help-circle-outline</v-icon>
			<v-tooltip activator="parent" location="top">
				{{ $t("tours.helpPanel.title") }}
			</v-tooltip>
		</v-btn>

		<v-dialog v-model="dialog" max-width="440">
			<v-card rounded="lg" elevation="1">
				<v-card-title class="bg-primary text-white d-flex align-center ga-2">
					<v-icon>mdi-help-circle-outline</v-icon>
					{{ $t("tours.helpPanel.title") }}
				</v-card-title>

				<v-card-text class="pt-4">
					<p class="text-body-2 mb-4">{{ pageDescription }}</p>
				</v-card-text>

				<v-card-actions>
					<v-spacer />
					<v-btn variant="text" @click="dialog = false">
						{{ $t("common.close") }}
					</v-btn>
					<v-btn
						color="primary"
						variant="flat"
						prepend-icon="mdi-play-circle-outline"
						@click="onRewatchTour"
					>
						{{ $t("tours.helpPanel.rewatchTour") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useTour } from "@/composables/useTour";

const { hasPageDescription, pageDescription, startGuidedTour } = useTour();

const dialog = ref(false);

function onRewatchTour() {
	dialog.value = false;
	// Espera o dialog do Vuetify fechar completamente (~300ms transição)
	// antes de iniciar o driver.js para evitar conflito de overlays
	setTimeout(() => {
		startGuidedTour();
	}, 400);
}
</script>

<style lang="scss" scoped>
.footer-help-btn {
	display: inline-flex;
	align-items: center;
}
</style>
